export const locale = {
    lang: 'tr',
    data: {
        'ORGANISATIONS': {
            'TITLE': 'ORGANISATIONS'
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/i18n/tr.ts